import { type AuthToken } from '@reliance/types/models/Auth';
import { type ApiService } from '../types/ApiService';

export const reports = (centralApi: ApiService, getToken: () => AuthToken) => ({
  getDailyUrl: (inmateId: number): string => {
    return centralApi.buildUrl('/report/mobile-device/daily', {
      inmateId: inmateId,
      token: getToken().accessToken,
    });
  },
  getSingleCallTranscription: (cdrId: number): string => {
    return centralApi.buildUrl('/report/transcription', {
      cdrId: cdrId,
      token: getToken().accessToken,
    });
  },
  getPurchasesAndActivityForCustomer: (ani: string): string => {
    return centralApi.buildUrl('/report/payments', {
      ani: ani,
      token: getToken().accessToken,
    });
  },
  getCustomersWithMultipleInmatePayments: (): string => {
    return centralApi.buildUrl('/report/payments/multiple', {
      token: getToken().accessToken,
    });
  },
  getPhoneAndVideoTranscriptions: (inmateId: number): string => {
    return centralApi.buildUrl('/report/transcriptions', {
      inmateId: inmateId,
      token: getToken().accessToken,
    });
  },
});
